import { atom } from "recoil";
import {
  DEFAULT_LENDER_PROFILES,
  DEFAULT_PRIMARY_LENDER,
} from "@/lib/lenderDefaults";

// Active lender configuration (primary lender + lender profiles). Seeded with
// code defaults; refreshed once from cpcore /public/lender-config at app start.
export const lenderConfigAtom = atom({
  key: "lenderConfigAtom",
  default: {
    primaryLender: DEFAULT_PRIMARY_LENDER,
    lenders: DEFAULT_LENDER_PROFILES,
  },
});
